import styled from "styled-components";

export const StyledContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  overflow: visible;
  width: 100%;
  height: 100dvh;
  background-color: #ffebc7;
  position: relative;
  justify-content: center;
  align-items: center;
`;

export const StyledConfettiLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
`;

export const StyledConfettiPiece = styled.span<{
  $left: number;
  $top: number;
  $rotate: number;
  $color: string;
}>`
  position: absolute;
  left: ${({ $left }) => $left}%;
  top: ${({ $top }) => $top}%;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background-color: ${({ $color }) => $color};
  transform: translate(-50%, -50%) rotate(${({ $rotate }) => $rotate}deg);
`;

export const StyledCardWrap = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 360px;
  /* 카드 box-shadow(0 8px 7px)가 캡처 프레임 안에 들어오도록 여백 */
  padding: 16px 40px 24px;
  box-sizing: border-box;
`;

export const StyledLogoImg = styled.img`
  width: 59px;
  height: 24.5px;
  margin: 33px auto auto;
`;
